import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { CoreObject } from "../../../core/geometry/Object";
import { CameraAttribute } from "../../../core/camera/CoreCamera";
import { CameraSopNodeType } from "../../poly/NodeContext";
import { CameraFrameMode, CAMERA_FRAME_MODES } from "../../../core/camera/CoreCameraFrameMode";
const _CameraFrameModeSopOperation = class extends BaseSopOperation {
  static type() {
    return CameraSopNodeType.FRAME_MODE;
  }
  cook(inputCoreGroups, params) {
    const objects = inputCoreGroups[0].objects();
    if (this._node) {
      _CameraFrameModeSopOperation.updateObject({ objects, params });
    }
    return this.createCoreGroupFromObjects(objects);
  }
  static updateObject(options) {
    const { objects, params } = options;
    for (let object of objects) {
      CoreObject.addAttribute(object, CameraAttribute.FRAME_MODE, params.frameMode);
      CoreObject.addAttribute(object, CameraAttribute.FRAME_MODE_EXPECTED_ASPECT_RATIO, params.expectedAspectRatio);
    }
  }
};
export let CameraFrameModeSopOperation = _CameraFrameModeSopOperation;
CameraFrameModeSopOperation.DEFAULT_PARAMS = {
  frameMode: CAMERA_FRAME_MODES.indexOf(CameraFrameMode.DEFAULT),
  expectedAspectRatio: 16 / 9
};
CameraFrameModeSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
